// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__xfFkE","pagination__page-panel":"Pagination_pagination__page-panel__L7TyF","pagination__page":"Pagination_pagination__page__yIWRo"};